import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Angulartics2 } from 'angulartics2';

import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';
import { AnalyticsService } from 'app/shared/analytics/analytics.service';
import { MathtagService } from 'app/shared/analytics/mathtag/mathtag.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { InscricaoService } from '../shared/inscricao.service';
import { FluxoVestibularService } from '../shared/fluxoVestibular.service';
import { AgendamentoService } from './agendamento.service';
import { PdfInscricaoService } from '../shared/pdf-inscricao.service';
import { environment } from '../../../../environments/environment';

import { AgendamentosDTO } from 'models/agendamentos';
import { DadosVestibular, InscricaoResponse } from 'models/dados-vestibular';
import { PdfDocInformacoesFinanceirasService } from '../../../restrito/contratante/matricular/shared/pdf/doc-informacoes-financeiras/pdf-doc-informacoes-financeiras.service';
import { NotificationsService } from 'angular2-notifications';
import { UploadImagemService } from 'app/shared/upload-imagem/upload-imagem.service';
import {NgxImageCompressService} from 'ngx-image-compress';


declare const gtag: Function;

@Component({
  moduleId: module.id.toString(),
  templateUrl: './agendamento.component.html',
  styleUrls: ['./agendamento.component.scss'],
  animations: [routerTransition],
  providers: [AgendamentoService],
})
export class AgendamentoComponent implements OnInit, OnDestroy {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  locais: any[] = [];
  datas: any[] = [];

  local: any = '';
  predioSala: any = '';
  data: any = '';
  canhoto = false;
  pne = false;
  tipoPne: any = '';
  dadosVestibular: DadosVestibular;
  numeroInscricao: any = '';
  valorVestibular: any;
  //escolaPublica: any = null; // Variável para Cotas - 4583: Thiago Augusto Lopes Silva

  agendamentoConcluido = false;
  loading = true;
  loadingDatas = false;
  dadosVestibularSubscription: Subscription;
  isReingresso = false;
  podeVoltar = true;
  provaOnline = false;
  alunoMigrado: any;
  tipoIngresso: any;
  tiposIngresso = new Array();

  formaDeIngressoSelecionada: string = '';

  //Inscrição enem
  public NUM_INSCRICAO_ENEM = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  public NOTA_MASK1: any;
  public NOTA_MASK2: any;
  public NOTA_MASK3: any;
  public NOTA_MASK4: any;
  public NOTA_MASK5: any;
  anoEnem: any;
  pontuacaoEnemE1: any;
  pontuacaoEnemE2: any;
  pontuacaoEnemE3: any;
  pontuacaoEnemE4: any;
  pontuacaoEnemRE: any;
  anos = [];
  sigla;
  numeroInscricaoEnem: any = '';
  documentoNotas: any = '';
  imagemDocReferencia: any =  true;
  imagemIdentReferencia: any = true;
  documentoVeracidadeInformacao: any = true;
  mediaTotal: any = 0;
  environment = environment;
  aceiteTermos = false;
  aceiteTermosDadosPessoais = false;

  public marketPlaceData;

  public podeAbrirVestibular: boolean = false;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private agendamentoService: AgendamentoService,
    private incricaoService: InscricaoService,
    private fluxoVestibularService: FluxoVestibularService,
    private blockingSpinnerService: BlockingSpinnerService,
    private pdfInscricaoService: PdfInscricaoService,
    private analytics: AnalyticsService,
    private mathtag: MathtagService,
    private angulartics2: Angulartics2,
    private pdfCartaCircularService: PdfDocInformacoesFinanceirasService,
    private notificationService: NotificationsService,
    private uploadImagemService: UploadImagemService,
    private imageCompress: NgxImageCompressService,
  ) { }

  ngOnInit() {

    this.marketPlaceData = JSON.parse(sessionStorage.getItem("marketPlaceData"));

    if(this.marketPlaceData != null){
      this.formaDeIngressoSelecionada = this.marketPlaceData['formaIngresso'];
    }

    if(this.formaDeIngressoSelecionada === "E" || this.formaDeIngressoSelecionada === "O"){
      this.selecionaFormaIngressoMKTPLC(this.formaDeIngressoSelecionada);
    }


    this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();

    if (!this.dadosVestibular) {
      return;
    }
    if (this.dadosVestibular.vestibular && this.dadosVestibular.vestibular.sigla === 'EA') {
      var campusId = this.dadosVestibular.cursoSelecionado.polo.id;
      var siglaCidade;
      switch(campusId){
        case "12": // Belém
          siglaCidade = "Belem";
          break;
        case "13": // São Luís
          siglaCidade = "SaoLuis";
          break;
        case "14": // Imperatriz
          siglaCidade = "Imperatriz";
          break;
        case "15": // Bacabal
          siglaCidade = "Bacabal";
          break;
        case "16": // Teresina
          siglaCidade = "Teresina";
          break;
        case "17": // Palmas
          siglaCidade = "Palmas";
          break;
        case "18": // Parnaíba
          siglaCidade = "Parnaiba";
          break;
      }
      this.angulartics2.eventTrack.next({
        action: `LeadVestibularAgendamento-${siglaCidade}`,
      });
    }

    this.podeVoltar = this.fluxoVestibularService.passoAtualRetornavel();
    if (!this.dadosVestibular.vestibular) {

      this.dadosVestibularSubscription = this.fluxoVestibularService.dadosVestibularMessage$.subscribe(() => {
        this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
        this.dadosVestibularSubscription.unsubscribe();
        this.init();
      });

    } else {
      this.init();
      this.analytics.registrar(
        `Vestibular`,
        `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
        'Agendamento',
      );
    }

    var tags;
    this.dadosVestibular.cursoSelecionado !== undefined &&
    this.dadosVestibular.cursoSelecionado.cidade !== undefined ?
      tags = this.getGtagAndMarketing(this.dadosVestibular.cursoSelecionado.cidade.id) : tags = this.getGtagAndMarketing(undefined);
    gtag('event', 'conversion', {'send_to': 'AW-794869491/rLgkCL3pxZ0BEPP9gvsC', 'Campus': tags.campus});

    // adicionando google tag e mathtag
    if (environment.production === 'true' && this.dadosVestibular.vestibular.sigla === 'EA') {
      gtag('event', 'conversion', { 'send_to': `${tags.code}/${tags.send_to}` , 'Campus': tags.campus});
      this.mathtag.inscricaoAgendamento(tags.mt_id);
    }
    // Medicina Ceuma Renascenca
    if(environment.production === 'true' && this.dadosVestibular.vestibular.id === '1' && environment.loginContexto === 'CEUMA') {
      gtag('event', 'conversion', {'send_to': 'AW-794869491/9M69CPb79akBEPP9gvsC'});
    }
    // Medicina Ceuma Imperatriz
    if(environment.production === 'true' && this.dadosVestibular.vestibular.id === '2' && environment.loginContexto === 'CEUMA') {
      gtag('event', 'conversion', {'send_to': 'AW-769032775/AZXYCPbe7KkBEMeE2u4C'});
    }
    // Medicina Unifamaz
    if(environment.production === 'true' && this.dadosVestibular.vestibular.id === '1' && environment.loginContexto === 'FAMAZ') {
      gtag('event', 'conversion', {'send_to': 'AW-769025589/__8eCJP49akBELXM2e4C'});
    }

    // Alteração 08/05/2020 - Vestibular com várias formas de ingresso
    this.buscarTipoIngresso();
    const anoHoje = new Date().getFullYear();
    this.anos = [anoHoje - 1, anoHoje - 2, anoHoje - 3, anoHoje - 4, anoHoje - 5];

  }



  getGtagAndMarketing(id = undefined){
    var tag = undefined;
    switch(id){
      // COMENTEI O CÓDIGO DA UNIEURO A PEDIDO DA CAMILA - 24/09/2019
      //case '09': //Polo Asa Sul - UNIEURO
        //tag = {'mt_id':'1388016','campus':'Polo Asa Sul','code':'AW-794869491','send_to':'Q0k-CNTtkpMBEPP9gvsC'};
        //break;
      //case '10': //Aguas Claras - UNIEURO
       // tag = {'mt_id':'1388016','campus':'Aguas Claras','code':'AW-794869491','send_to':'Q0k-CNTtkpMBEPP9gvsC'};
       // break;
      //case '11': //Asa Norte - UNIEURO
       // tag = {'mt_id': '1388016','campus':'Asa Norte','code':'AW-794869491','send_to':'Q0k-CNTtkpMBEPP9gvsC'};
       // break;
      case '12': //Polo Belem - FAMAZ
        tag = {'mt_id':'1388189','campus':'Polo Belem','code':'AW-769025589','send_to':'A0lGCPHjkpMBELXM2e4C'};
        break;
      case '13': //Polo Sao Luis
        tag = {'mt_id':'1348906','campus':'Polo Sao Luis','code':'AW-794869491','send_to':'Q0k-CNTtkpMBEPP9gvsC'};
        break;
      case '14': //Polo Imperatriz
        tag = { 'mt_id': '1348906' , 'campus': 'Polo Imperatriz','code':'AW-769032775','send_to':'AW-769032775/LGNICIT3mZMBEMeE2u4C'};
        break;
      case '15': //Polo Bacabal
        tag = {'mt_id':'1348906','campus':'Polo Bacabal','code':'AW-763364040','send_to':'DJ-UCOKViZUBEMiFgOwC'};
        break;
      case '16': //Polo Teresina
        tag = {'mt_id': '1388205','campus':'Polo Teresina','code':'AW-769019678','send_to':'LSQlCOPhkpMBEJ6e2e4C'};
        break;
      case '17': //Polo Palmas
        tag = {'mt_id':'1348906','campus':'Polo Palmas','code':'AW-769681334','send_to':'EPjECJnrkpMBELbPge8C'};
        break;
      case '18': //Polo Parnaiba
        tag = {'mt_id':'1388205','campus':'Polo Parnaiba','code':'AW-756110781','send_to':'2O7wCJe7_JYBEL2rxegC'};
        break;
      default:
        tag = { 'mt_id': '1348906' , 'campus': 'Polo Sao Luis','code':'AW-794869491','send_to':'Q0k-CNTtkpMBEPP9gvsC'};
        break;
    }
    return tag;
  }

  ngOnDestroy() {
    if (environment.production === 'true' && this.dadosVestibular.vestibular.sigla === 'EA') {
      this.mathtag.removerTodosScripts();
    }
  }

  init() {
    if (this.dadosVestibular && this.dadosVestibular.vestibular) {
      this.isReingresso = this.dadosVestibular.vestibular.isReingresso;
    }

    this.agendamentoConcluido = false;
    if (this.dadosVestibular && this.dadosVestibular.agendamento) {
      this.local = this.dadosVestibular.agendamento.local;
      this.data = this.dadosVestibular.agendamento.data;
      this.canhoto = this.dadosVestibular.agendamento.canhoto;
      this.pne = this.dadosVestibular.agendamento.pne;
      this.tipoPne = this.dadosVestibular.agendamento.tipoPne;
      if (this.dadosVestibular.agendamento.numeroInscricao) {
        this.numeroInscricao = this.dadosVestibular.agendamento.numeroInscricao;
        this.agendamentoConcluido = true;
      }
    }

    this.buscarCampusAgendamento();
  }

  async buscarCampusAgendamento() {
    try {
      const { sigla } = this.dadosVestibular.vestibular;
      const agendamentosDTO: any = await this.agendamentoService.buscarCampusAgendamento(sigla);
      if (!agendamentosDTO) {
        throw new Error('Não foi possível recuperar os campus para agendamento.');
      }
      this.locais = agendamentosDTO.campus;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    } finally {
      this.loading = false;
    }
  }

  async buscarDatasDisponiveis({ codigo, ano, campus }) {
    const agendamentosDTO = await this.agendamentoService.buscarDatasDisponiveis(ano, codigo, campus);
    return agendamentosDTO;
  }

  mergeDatasLocal({ locais, resultDatas, localParam }) {
    locais.forEach(local => {
      if (local.codigo === localParam.codigo) {
        local.datas = resultDatas.datas;
      }
    });
  }

  async buscarDatasDisponiveisPorCampus(localParam) {
    this.loadingDatas = true;
    this.data = '';
    try {
      const campus = localParam.codigo;
      if (localParam.datas) {
        this.datas = localParam.datas;
      } else {
        const { codigo, ano } = this.dadosVestibular.vestibular.id;
        if (!codigo || !ano) {
          throw new Error('Não foi possível recuperar o código ou ano do vestibular.');
        }
        const resultDatas: any = await this.buscarDatasDisponiveis({ codigo, ano, campus });
        this.mergeDatasLocal({ locais: this.locais, resultDatas, localParam });
        this.datas = resultDatas.datas;
      }
    } catch (error) {
      throw new Error(error);
    } finally {
      this.loadingDatas = false;
    }
  }

  buscarAgendamentos(id, ano, sigla) {
    this.agendamentoService.buscarAgendamentos(id, ano, sigla)
      .then((agendamentosDTO: AgendamentosDTO) => {
        this.locais = agendamentosDTO.locais;
        this.datas = agendamentosDTO.datas;
        this.loading = false;
      },
        resp => {
          console.error(resp.err.mensagem);
          this.loading = false;
        },
      );
  }

  disableBtnAgendar() {
    if (this.tipoIngresso === 'O') {
      return false;
    }
    if(this.tipoIngresso === 'E'){
      //Caso o vestibular seja de ENEM
      // Cálculo da nota final
      // Precisamos das médias de área de conhecimento
      let mediaNotaAreasConhecimento = (parseFloat(this.pontuacaoEnemE1)+
                                       parseFloat(this.pontuacaoEnemE2)+
                                       parseFloat(this.pontuacaoEnemE3)+
                                       parseFloat(this.pontuacaoEnemE4))/4;
      // A média das áreas de conhecimento é então somada com a nota do ENEM e /2
      let media = (mediaNotaAreasConhecimento+parseFloat(this.pontuacaoEnemRE))/2;
      this.mediaTotal = parseFloat(media.toString()).toFixed(2);
      // Por fim verifica o valor dessa média
      // Se for menor que 650, o candidato não pode passar
      //console.log(this.mediaTotal);
      if(this.mediaTotal<300 || this.mediaTotal>1000) return true;


      let pontuacaoMinima=0.000;
      let pontuacaoMaxima=1000.000;
      if(!this.pontuacaoEnemE1 || parseFloat(this.pontuacaoEnemE1)>pontuacaoMaxima || parseFloat(this.pontuacaoEnemE1)<=pontuacaoMinima)return true;
      if(!this.pontuacaoEnemE2 || parseFloat(this.pontuacaoEnemE2)>pontuacaoMaxima || parseFloat(this.pontuacaoEnemE2)<=pontuacaoMinima)return true;
      if(!this.pontuacaoEnemE3 || parseFloat(this.pontuacaoEnemE3)>pontuacaoMaxima || parseFloat(this.pontuacaoEnemE3)<=pontuacaoMinima)return true;
      if(!this.pontuacaoEnemE4 || parseFloat(this.pontuacaoEnemE4)>pontuacaoMaxima || parseFloat(this.pontuacaoEnemE4)<=pontuacaoMinima)return true;
      if(!this.pontuacaoEnemRE || parseFloat(this.pontuacaoEnemRE)>pontuacaoMaxima || parseFloat(this.pontuacaoEnemRE)<=pontuacaoMinima)return true;


      /**
       * Imagens e documentos
       */
      //if(!this.documentoNotas || this.documentoNotas=='') return true;
      if(!this.documentoNotas) return true;
      if(!this.anoEnem) return true;
      if(!(this.numeroInscricaoEnem>0)) return true;

      //console.log(this.aceiteTermos);
      //console.log(this.aceiteTermosDadosPessoais);
      if(!(this.aceiteTermosDadosPessoais && this.aceiteTermos)) return true;

      return false;
    }

    if (this.dadosVestibular.vestibular.codigo !== 1 || this.dadosVestibular.vestibular.codigo !== 2) {
      if (this.agendamentoConcluido) {
        return true;
      }
      if (!this.local || !this.data) {
        return true;
      }
      if (this.pne && this.tipoPne === '') {
        return true;
      }
    }

  }

  async gerarCartaoInscricao() {
    try {
      this.blockingSpinnerService.show();
      /**
       * 4583 - Thiago Augusto
       * 11/03/2020 - Automatização da geração de documentos - DocCeuma
       */
      //await this.pdfInscricaoService.gerarPDF(this.dadosVestibular); -- Não preciso mais utilizar este método para gerar o cartão de inscrição
      //this.pdfInscricaoService.gerarPDFDocCeuma(this.dadosVestibular);
      await this.pdfInscricaoService.gerarPDFDocCeuma(this.dadosVestibular).subscribe((data)=>{
        this.pdfCartaCircularService.handleFile(data,`Cartão Inscrição - ${this.dadosVestibular.agendamento.numeroInscricao}.pdf`);
        this.blockingSpinnerService.close();
      },(error)=>{
        console.log(error);
        this.notificationService.error('Erro', 'Ocorreu um erro na geração do PDF do Documento de Informações Financeiras');
        this.blockingSpinnerService.close();
      });
    } finally {
      this.blockingSpinnerService.close();
    }
  }

  nextStep() {
    this.fluxoVestibularService.proximoPasso();
    const proximaRota = this.fluxoVestibularService.proximaRota();
    this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });
  }

  compararLocalOuData(item1, item2): boolean {
    return item1 && item2 && item1.descricao === item2.descricao;
  }

  voltar() {
    this.fluxoVestibularService.voltarPasso();

    const rotaAnterior = this.fluxoVestibularService.rotaAnterior();
    this.router.navigate([`../${rotaAnterior}`], { relativeTo: this.route });
  }

  async agendar() {
    this.blockingSpinnerService.show();
    if(this.tipoIngresso === 'A') {
      // Agendado
      console.log('AGENDADO');
      this.fluxoVestibularService.setDadosVestibular({
        agendamento: {
          local: this.local,
          data: this.data,
          canhoto: this.canhoto,
          pne: this.pne,
          tipoPne: this.tipoPne,
        },
      });
      this.fluxoVestibularService.setDadosVestibular({provaOnline: false})
      this.analytics.registrar('Vestibular', 'Locais de agendamento', this.local.descricao);
      this.analytics.registrar('Vestibular', 'Datas de agendamento', this.data.descricaoFull);
    }
    else if (this.dadosVestibular.vestibular.codigo === 1) {
      await this.buscarDatasDisponiveisPorCampus(this.locais[0]);
      this.tipoIngresso = 'ME';
      this.fluxoVestibularService.setDadosVestibular({
        agendamento: {
          local: this.locais[0],
          data: this.datas[0],
          canhoto: false,
          pne: false,
          tipoPne: '',
        }
      });

      console.log("Local: ", this.locais[0])
      this.fluxoVestibularService.setDadosVestibular({provaOnline: false});
      this.analytics.registrar('Vestibular', 'Locais de agendamento', this.locais[0].descricao);
      this.analytics.registrar('Vestibular', 'Datas de agendamento', this.datas[0].descricaoFull);
    }

    else if (this.dadosVestibular.vestibular.codigo === 1) {
      await this.buscarDatasDisponiveisPorCampus(this.locais[0]);
      this.tipoIngresso = 'MN';
      this.fluxoVestibularService.setDadosVestibular({
        agendamento: {
          local: this.locais[0],
          data: this.datas[0],
          canhoto: false,
          pne: false,
          tipoPne: '',
        }
      });

      console.log("Local: ", this.locais[0])
      this.fluxoVestibularService.setDadosVestibular({provaOnline: false});
      this.analytics.registrar('Vestibular', 'Locais de agendamento', this.locais[0].descricao);
      this.analytics.registrar('Vestibular', 'Datas de agendamento', this.datas[0].descricaoFull);
    }
    else if(this.tipoIngresso === 'E'){
      //Enem
      console.log('ENEM');
      this.fluxoVestibularService.setDadosVestibular({
        enem:{
          ano: this.anoEnem,
          numeroInscricao: this.numeroInscricaoEnem,
          pontuacaoEnemE1: this.pontuacaoEnemE1,
          pontuacaoEnemE2: this.pontuacaoEnemE2,
          pontuacaoEnemE3: this.pontuacaoEnemE3,
          pontuacaoEnemE4: this.pontuacaoEnemE4,
          pontuacaoEnemRE: this.pontuacaoEnemRE,
        }
      });
      this.fluxoVestibularService.setDadosVestibular({provaOnline: true}); //Não possui agendamento
    }
    else{
      //Prova Online
      console.log('PROVA ONLINE');
      this.fluxoVestibularService.setDadosVestibular({agendamento:{}});
      this.fluxoVestibularService.setDadosVestibular({provaOnline: true}) //Não possui agendamento
    }

    this.incricaoService.inscrever(this.fluxoVestibularService.getDadosVestibular()).then(
      async (data: InscricaoResponse) => {
        if(this.tipoIngresso==='A'){
          // Agendado
          this.local.predioSala = `${data.agendamento.predio}, ${data.agendamento.sala}`;
          this.numeroInscricao = data.numeroInscricao;
          this.agendamentoConcluido = true;
          this.valorVestibular = data.valorVestibular;
          this.fluxoVestibularService.setDadosVestibular({
            agendamento: {
              local: this.local,
              data: this.data,
              canhoto: this.canhoto,
              pne: this.pne,
              tipoPne: this.tipoPne,
              numeroInscricao: this.numeroInscricao,
              valorVestibular: data.valorVestibular
            },
          });
        } else if (this.dadosVestibular.vestibular.codigo === 1 && environment.loginContexto === 'EURO') {
          await this.buscarDatasDisponiveisPorCampus(this.locais[0]);

          this.numeroInscricao = data.numeroInscricao;
          this.tipoIngresso = 'ME';
          this.agendamentoConcluido = true;
          this.valorVestibular = data.valorVestibular;
          this.fluxoVestibularService.setDadosVestibular({
            agendamento: {
              local: this.locais[0],
              data: this.datas[0],
              canhoto: false,
              pne: false,
              tipoPne: '',
              numeroInscricao: this.numeroInscricao,
              valorVestibular: data.valorVestibular,
            }
          });
        } else if (this.dadosVestibular.vestibular.codigo === 2 && environment.loginContexto === 'EURO') {
          await this.buscarDatasDisponiveisPorCampus(this.locais[0]);

          this.numeroInscricao = data.numeroInscricao;
          this.tipoIngresso = 'MN';
          this.agendamentoConcluido = true;
          this.valorVestibular = data.valorVestibular;
          this.fluxoVestibularService.setDadosVestibular({
            agendamento: {
              local: this.locais[0],
              data: this.datas[0],
              canhoto: false,
              pne: false,
              tipoPne: '',
              numeroInscricao: this.numeroInscricao,
              valorVestibular: data.valorVestibular,
            }
          });
        } else if(this.tipoIngresso==='E'){
          // Enem
          this.numeroInscricao = data.numeroInscricao;
          this.valorVestibular = data.valorVestibular;
          this.local = {predioSala : null};
          this.agendamentoConcluido = true;
          // this.alunoMigrado = this.incricaoService.migraAlunoProvaOnlineMoodle(this.fluxoVestibularService.getDadosVestibular(),this.numeroInscricao);
          this.fluxoVestibularService.setDadosVestibular({
            agendamento: {
              local: null,
              data: null,
              canhoto: null,
              pne: null,
              tipoPne: null,
              numeroInscricao: this.numeroInscricao,
              valorVestibular: data.valorVestibular
            },
          });
        } else {
          this.numeroInscricao = data.numeroInscricao;
          this.valorVestibular = data.valorVestibular;
          this.local = {predioSala : null};
          this.agendamentoConcluido = true;
          this.alunoMigrado = this.incricaoService.migraAlunoProvaOnlineMoodle(this.fluxoVestibularService.getDadosVestibular(), this.numeroInscricao);
          this.fluxoVestibularService.setDadosVestibular({
            agendamento: {
              local: null,
              data: null,
              canhoto: null,
              pne: null,
              tipoPne: null,
              numeroInscricao: this.numeroInscricao,
              valorVestibular: data.valorVestibular
            },
          });
        }

        this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
        this.podeVoltar = this.fluxoVestibularService.passoAtualRetornavel();
        this.blockingSpinnerService.close();
        this.analytics.registrar(
          `Vestibular`,
          `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
          'Cartão de inscrição',
        );
      },

      resp => {
        console.error(resp.erro.mensagem);
        this.blockingSpinnerService.close();
      },
    );
  }

  mostrarAgendamento(){
    this.provaOnline=false;
  }

  esconderAgendamento(){
    this.provaOnline=true;
  }

  buscarTipoIngresso(){
    /**
     * Dependendo da sigla do vestibular, o tipo de ingresso será diferente
     */
    let info;
    if(this.dadosVestibular.vestibular.sigla=='AE'){

    }
    //console.log(this.dadosVestibular.vestibular.sigla);
    switch(this.dadosVestibular.vestibular.sigla){
      // Agendado
      case 'AE':
      case 'AG':
      case 'AO':
      case 'AEO':
      case 'RE':
        info = {valor: 'A', tipo: 'Prova agendada'};
        this.tiposIngresso.push(info);
      case 'RM':
        info = {valor: 'A', tipo: 'Prova agendada'};
        this.tiposIngresso.push(info);
    }
    switch(this.dadosVestibular.vestibular.sigla){
      case 'AO':
      case 'AEO':
      case 'EO':
        info = {valor: 'O', tipo: 'Redação Digital'};
        this.tiposIngresso.push(info);

        // if(this.dadosVestibular.vestibular['anoSemestre'] == '2022.1'){
        //   this.tiposIngresso.push(info);
        // }

    }
    switch(this.dadosVestibular.vestibular.sigla){
      // Enem
      case 'AE':
      case 'EN':
      case 'AEO':
      case 'EO':
        info = {valor: 'E', tipo: 'Digitar nota do Enem'};
        this.tiposIngresso.push(info);
        break;
    }
  }
  selecionarAnoEnem(e) {
    this.anoEnem = e.target.value;
    console.log('ano selecionado: ', this.anoEnem);
  }

  validarNota1(event) {
    const numHundread = event.target.value.substring(0, 3);
    const notaMax = 1000;
    if (event.keyCode == '8') {
      this.pontuacaoEnemE1 = '';
    }
    if (numHundread * 10 > notaMax) {
      this.NOTA_MASK1 = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    } else {
      this.NOTA_MASK1 = [/[1-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/]; // 1000.000
      if (this.pontuacaoEnemE1 > notaMax) {
        this.pontuacaoEnemE1 = 1000.000;
      }
    }
  }

  validarNota2(event) {
    const numHundread = event.target.value.substring(0, 3);
    const notaMax = 1000;
    if (event.keyCode == '8') {
      this.pontuacaoEnemE2 = '';
    }
    if (numHundread * 10 > notaMax) {
      this.NOTA_MASK2 = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    } else {
      this.NOTA_MASK2 = [/[1-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
      if (this.pontuacaoEnemE2 > notaMax) {
        this.pontuacaoEnemE2 = 1000.000;
      }
    }
  }

  validarNota3(event) {
    const numHundread = event.target.value.substring(0, 3);
    const notaMax = 1000;
    if (event.keyCode == '8') {
      this.pontuacaoEnemE3 = '';
    }
    if (numHundread * 10 > notaMax) {
      this.NOTA_MASK3 = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    } else {
      this.NOTA_MASK3 = [/[1-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
      if (this.pontuacaoEnemE3 > notaMax) {
        this.pontuacaoEnemE3 = 1000.000;
      }
    }
  }

  validarNota4(event) {
    const numHundread = event.target.value.substring(0, 3);
    const notaMax = 1000;
    if (event.keyCode == '8') {
      this.pontuacaoEnemE4 = '';
    }
    if (numHundread * 10 > notaMax) {
      this.NOTA_MASK4 = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    } else {
      this.NOTA_MASK4 = [/[1-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
      if (this.pontuacaoEnemE4 > notaMax) {
        this.pontuacaoEnemE4 = 1000.000;
      }
    }
  }

  validarNota5(event) {
    //console.log(event)
    const numHundread = event.target.value.substring(0, 3);
    const notaMax = 1000;
    if (event.keyCode == '8') {
      this.pontuacaoEnemRE = '';
    }
    if (numHundread * 10 > notaMax) {
      this.NOTA_MASK5 = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    } else {
      this.NOTA_MASK5 = [/[1-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
      if (this.pontuacaoEnemRE > notaMax) {
        this.pontuacaoEnemRE = 1000.000;
      }
    }
  }
  // Vestibular Medicina ENEM
  async onDocumentSelected(image){
    //console.log(img);
    //console.log(document);
    //Documento inserido separadamente
    this.blockingSpinnerService.show();
    let img = await this.compress(image);
    this.uploadImagemService.uploadImagem(
      this.dadosVestibular.vestibular.ano,
      this.dadosVestibular.vestibular.codigo,
      this.dadosVestibular.candidato.cpf.replace(/[^\d]+/g, ''),
      null,
      //Vestibular ENEM Medicina
      img,
      null,
      null,
      null
    ).then(()=>{
      //console.log('deu ruim');
      this.documentoNotas = document;
      this.blockingSpinnerService.close();
    })
    .catch((err)=>{
      this.documentoNotas = false;
      this.blockingSpinnerService.close();
    })

  }

  acessarMatriculaDigital(){
    window.location.href = `${environment.apiBaseUrl}matricula-digital/login`;
  }

  acessaRedacaoDigital(dadosVestibular) {
    this.incricaoService.acessaRedacaoDigital(this.numeroInscricao);
  }

  async compress(image){
    let img;
    //console.log('Size in bytes was: ', this.imageCompress.byteCount(image.image));
    await this.imageCompress.compressFile(image.image, null, 70, 70).then((result) => {
      img = result;
      //console.log('Size in byte after compress: ', this.imageCompress.byteCount(this.imgResultAfterCompress));
    });
    //console.log(img);
    return img;
  }

  async selecionaFormaIngresso(event) {
    const tipo = event.target.value;
    this.tipoIngresso = tipo;

    //----- ALTERAÇÕES PARA VESTIBULAR DE MEDICINA REINGRESSO 2021.2 --------
    await this.buscarDatasDisponiveisPorCampus(this.locais[0]);
    this.local = this.locais[0];
    this.data = this.datas[0];
  }

  selecionaFormaIngressoMKTPLC(event){
    const tipo = event;
    this.tipoIngresso = tipo;
  }
}
